

import CommonApi from './../commonApi';

const stock = new CommonApi('stock', 'Склады');

export default {
  ...stock
};
